export {default} from './Listings';



// WEBPACK FOOTER //
// ./src/pages/Listings/index.ts